import { forwardRef, useId } from 'react'

import { computeSize } from '../shared'
import type { IconProps } from '../shared'

/**
 * This icon has complex SVG content (clipPath, defs) that requires
 * a custom implementation instead of the createIcon factory.
 */
const TagProfileIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ size = 'small', className, color = 'currentColor', ...props }, ref) => {
    const computedSize = computeSize(size)
    const clipPathId = useId()

    return (
      <svg
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M10.666 11.4998H1.33203C1.19942 11.4998 1.07225 11.4471 0.978478 11.3533C0.88471 11.2596 0.832031 11.1324 0.832031 10.9998V10.3228C0.832958 9.49134 1.16365 8.69423 1.75157 8.10631C2.33948 7.5184 3.1366 7.18771 3.96803 7.18678H8.03003C8.86129 7.18784 9.6582 7.51852 10.246 8.10631C10.8338 8.69411 11.1645 9.49102 11.1655 10.3223V10.9998C11.1655 11.1324 11.1129 11.2596 11.0191 11.3533C10.9253 11.4471 10.7986 11.4998 10.666 11.4998ZM5.99903 6.63428C5.40569 6.63428 4.82567 6.45833 4.33232 6.12869C3.83897 5.79904 3.45446 5.33051 3.22739 4.78233C3.00033 4.23415 2.94092 3.63095 3.05668 3.04901C3.17243 2.46706 3.45815 1.93252 3.87771 1.51296C4.29727 1.0934 4.83182 0.807679 5.41376 0.691923C5.9957 0.576167 6.5989 0.635577 7.14708 0.86264C7.69526 1.0897 8.1638 1.47422 8.49344 1.96757C8.82308 2.46092 8.99903 3.04093 8.99903 3.63428C8.99811 4.42964 8.68174 5.19217 8.11933 5.75458C7.55692 6.31698 6.7944 6.63335 5.99903 6.63428Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

TagProfileIcon.displayName = 'TagProfileIcon'

export { TagProfileIcon }
